import { render, staticRenderFns } from "./CourseCardV3.vue?vue&type=template&id=0daa0f44&scoped=true&"
import script from "./CourseCardV3.vue?vue&type=script&lang=js&"
export * from "./CourseCardV3.vue?vue&type=script&lang=js&"
import style0 from "./CourseCardV3.vue?vue&type=style&index=0&id=0daa0f44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daa0f44",
  null
  
)

export default component.exports